import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Tooltip as MuiTooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const RecentInfo = ({ visitorsData = [], requestsData = [], paymentsData = [] }) => {
    const [activeTab, setActiveTab] = useState('payments');
    const navigate = useNavigate();

    const handleNavigate = () => {
        switch (activeTab) {
            case 'payments':
                navigate('/balance-transactions');
                break;
            case 'requests':
                navigate('/requests/requests');
                break;
            case 'visitors':
                navigate('/visitors');
                break;
            case 'parcels':
                navigate('/parcels');
                break;
            default:
                break;
        }
    }

    const getColumns = () => {
        switch (activeTab) {
            case 'payments':
                return ['Unit', 'Account Name', 'Amount', 'Payment Date'];
            case 'requests':
                return ['Unit', 'Assignee', 'Type', 'Date Created'];
            case 'visitors':
                return ['Unit', 'Name', 'Date Checked-In'];
            case 'parcels':
                return ['Unit', 'Status', 'Notified', 'Date Delivered'];
            default:
                return [];
        }
    };

    const getRows = () => {
        switch (activeTab) {
            case 'payments':
                const finalPaymentsData = []
                for (const payment of paymentsData) {
                    for (const allocation of payment.allocations) {
                        let amount = "PHP " + allocation.allocatedAmount;
                        let unit = allocation.itemId.unit.unitNumber;
                        let paymentDate = payment.payment.paymentDate;
                        let name = payment.payment.invoiceId.chargedTo.propertyRole.account.user.givenName + " " + payment.payment.invoiceId.chargedTo.propertyRole.account.user.lastName;

                        finalPaymentsData.push([
                            unit,
                            name,
                            amount,
                            paymentDate
                        ]);
                    }
                }
                return finalPaymentsData;
            case 'parcels':
                return []; // No data
            case 'visitors':
                return visitorsData.map((visitor) => [
                    visitor.unit?.unitNumber || '',
                    `${visitor.givenName} ${visitor.lastName}`,
                    new Date(visitor.checkIn).toLocaleDateString() || '',
                ]);
            case 'requests':
                return requestsData.map((request) => [
                    request.unit?.unitNumber || '',
                    (() => {
                        const assigneeNames = (request.assignees || [])
                            .map((a) => `${a.user?.givenName || ''} ${a.user?.lastName || ''}`.trim())
                            .filter((name) => name)
                            .join(', ');
                        return assigneeNames || '-';
                    })(),
                    request.type || '',
                    request.createdAt ? new Date(request.createdAt).toLocaleDateString() : '',
                ]);
            default:
                return [];
        }
    };

    useEffect(() => {
        console.log('Requests Data:', requestsData);
    }, [requestsData]);

    const columns = getColumns();
    const rows = getRows();
    const rowCount = Math.max(6, rows.length);

    return (
        <div className="card" style={{ width: "100%" }}>
            <div className="tooltip-header" style={{ display: "flex", alignItems: "center" }}>
                <MuiTooltip title="These are the recent payments, requests, visitors, and parcels of a unit." arrow>
                    <IconButton>
                        <HelpOutlineIcon sx={{ fontSize: '18px', color: 'grey' }} />
                    </IconButton>
                </MuiTooltip>
                <button className="redirect-btn" onClick={handleNavigate}>
                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                </button>
            </div>

            <h2 className="card-title"><i className="fa fa-clipboard-list" />Recent Resident Services</h2>

            <div className="recent-info flex-col md:flex-row">
                <div className="recent-table-container order-2 md:order-1">
                    <table className="recent-table">
                        <thead>
                            <tr>
                                {columns.map((col, idx) => (
                                    <th key={idx}>{col}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 ? (
                                <>
                                    <tr>
                                        <td colSpan={columns.length} style={{ textAlign: "center", padding: "1rem" }}>
                                            No recent services found.
                                        </td>
                                    </tr>
                                    {[...Array(5)].map((_, index) => (
                                        <tr key={index}>
                                            {columns.map((_, colIdx) => (
                                                <td key={colIdx}>{'\u00A0'}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </>
                            ) : (
                                [...Array(rowCount)].map((_, index) => (
                                    <tr key={index}>
                                        {columns.map((_, colIdx) => (
                                            <td key={colIdx}>{rows[index]?.[colIdx] || '\u00A0'}</td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="recent-buttons order-1 md:order-2 grid grid-cols-2 gap-2 md:flex md:flex-col">
                    {['payments', 'requests', 'visitors', 'parcels'].map((tab) => {
                        let count = 0;
                        if (tab === 'visitors') count = visitorsData.length;
                        else if (tab === 'requests') count = requestsData.length;
                        else if (tab === 'payments') count = paymentsData.length;

                        return (
                            <div
                                key={tab}
                                className="recent-button w-full h-full flex flex-col items-center justify-center"
                                onClick={() => setActiveTab(tab)}
                                style={{
                                    backgroundColor: activeTab === tab ? '#C86B2C' : '#D4967D',
                                    cursor: 'pointer',
                                }}
                            >
                                <p className="recent-value text-2xl md:text-4xl w-full md:w-[60px]">{count}</p>
                                <p className="recent-type text-sm md:text-base w-full md:w-[80px]">
                                    Recent<br />{tab.charAt(0).toUpperCase() + tab.slice(1)}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default RecentInfo;